<!--
 * @Description: 项目执行人数据统计
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div>
    <component :is="cmpName" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import * as BiTmplDetail_4_s from './components';
import { useBiTmplDetailSteup } from '../../../store';
import { storeToRefs } from 'pinia';

const store = useBiTmplDetailSteup();
const { state } = storeToRefs(store);

const cmpName = computed(() => {
  return BiTmplDetail_4_s['BiTmplDetail_' + state.value.activeMenu[1]];
});
</script>
<style scoped lang="scss"></style>
